import { createSlice } from "@reduxjs/toolkit";
import Swal from 'sweetalert2';
import { getAllOrder, exportOrders, addTreatment, changeStatus, reschedule, addNote, addOrder } from "./Utils/orderUtils";

const initialState = {
    filters: {
        // "filter[id]": "",
        "filter[status]": "",
        "filter[type]": "",
        // "filter[payment_method]": "",
        "filter[start_date]": "",
        "filter[end_date]": "",
        "filter[user.name]": "",
        "filter[branch_id]": "", //get all branch
        "sort": "",
        "page": "",
    },
    orders: [],
    pagination: {},
    loading: false,
    error: null,
    setupOrder: {
        id: null,
        loading: false,
        branch_id: "",
        status: "",
        schedule_date: "",
        schedule_hour_start: "",
        schedule_hour_end: "",
        treatment_ids: [],
        cs_notes: "",
    },
};

const orderSlice = createSlice({
    name: "order",
    initialState,
    reducers: {
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters: (state) => {
            state.filters = initialState.filters;
        },
        setSetupOrder: (state, action) => {
            state.setupOrder = { ...state.setupOrder, ...action.payload };
        },
        resetSetupOrder: (state) => {
            state.setupOrder = initialState.setupOrder;
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllOrder.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllOrder.fulfilled, (state, action) => {
                state.loading = false;
                state.orders = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(getAllOrder.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(addOrder.pending, (state) => {
                state.setupOrder.loading = true;
                state.error = null;
            })
            .addCase(addOrder.fulfilled, (state, action) => {
                state.setupOrder.loading = false;
                state.setupOrder = initialState.setupOrder;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Berhasil Menambahkan Reservasi Offline',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
            })
            .addCase(addOrder.rejected, (state, action) => {
                state.setupOrder.loading = false;
                state.error = action.payload;
            })

            .addCase(exportOrders.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(exportOrders.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(exportOrders.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(addTreatment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addTreatment.fulfilled, (state, action) => {
                state.loading = false;
                state.setupOrder.treatment_ids = [];
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Berhasil Menambahkan Perawatan',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
            })
            .addCase(addTreatment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(addNote.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addNote.fulfilled, (state, action) => {
                state.loading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Berhasil Menambahkan Catatan',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
            })
            .addCase(addNote.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(changeStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(changeStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.setupOrder.status = "";
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Berhasil Mengubah Status Reservasi',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
            })
            .addCase(changeStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(reschedule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(reschedule.fulfilled, (state, action) => {
                state.loading = false;
                state.setupOrder.schedule_date = "";
                state.setupOrder.schedule_hour_start = "";
                state.setupOrder.schedule_hour_end = "";
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Berhasil Menjadwalkan Ulang Reservasi',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
            })
            .addCase(reschedule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { setFilters, resetFilters, setSetupOrder, resetSetupOrder } = orderSlice.actions;

export default orderSlice.reducer;
